"use strict";
var btnAppendRow = document.querySelector(".append-row");
var btnRemoveRow = document.querySelector(".remove-row");
var btnAppendColumn = document.querySelector(".append-column");
var btnRemoveColumn = document.querySelector(".remove-column");
var table = document.querySelector("table");
var rowsCount = document.querySelectorAll("tr").length;
var firstRow = document.querySelector("table tr");
var colsCount = firstRow ? firstRow.querySelectorAll("td, th").length : 0;
var maxCount = 10;
var minCount = 2;
function updateButtons() {
    btnAppendRow.disabled = rowsCount >= maxCount;
    btnRemoveRow.disabled = rowsCount <= minCount;
    btnAppendColumn.disabled = colsCount >= maxCount;
    btnRemoveColumn.disabled = colsCount <= minCount;
}
btnAppendRow.addEventListener("click", function(e) {
    var newRow = document.createElement("tr");
    if (rowsCount < maxCount) {
        for(var i = 0; i < colsCount; i++)newRow.appendChild(document.createElement("td"));
        var tbody = table.querySelector("tbody") || table;
        tbody.appendChild(newRow);
        rowsCount++;
    }
    updateButtons();
});
btnAppendColumn.addEventListener("click", function(e) {
    var rows = document.querySelectorAll("tr");
    if (colsCount < maxCount) {
        for(var i = 0; i < rows.length; i++)rows[i].appendChild(document.createElement("td"));
        colsCount++;
    }
    updateButtons();
});
btnRemoveRow.addEventListener("click", function(e) {
    if (rowsCount > minCount) {
        var rows = document.querySelectorAll("tr");
        rows[rows.length - 1].remove();
        rowsCount--;
    }
    updateButtons();
});
btnRemoveColumn.addEventListener("click", function(e) {
    var rows = document.querySelectorAll("tr");
    if (colsCount > minCount) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                var cells = row.querySelectorAll("td, th");
                if (cells.length > 0) cells[cells.length - 1].remove();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        colsCount--;
    }
    updateButtons();
});
updateButtons();

//# sourceMappingURL=index.d8dcb9a5.js.map
